module.exports = __webpack_public_path__ + "assets/img/Batsman.png?a3018f7dccd6ce003ff0b97eb874c2ec";